import { z } from "zod";
import { cautionStatusSchema } from "./caution-status.js";
export const cautionResponseSchema = z.object({
    id: z.string(),
    owner_id: z.string(),
    tenant_id: z.string(),
    amount: z.number().int(),
    note: z.string().nullable(),
    status: cautionStatusSchema,
    release_date: z.iso.datetime(),
    released_at: z.iso.datetime().nullable(),
    canceled_at: z.iso.datetime().nullable(),
    retained_amount: z.number().int().nullable(),
    release_note: z.string().nullable(),
    provider: z.string(),
    provider_id: z.string().nullable(),
    provider_url: z.string().nullable(),
    paid_at: z.iso.datetime().nullable(),
    last_email_sent_at: z.iso.datetime().nullable(),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime(),
});
